<template>
  <v-card class="card-box" elevation="0">
    <v-card-text class="pa-0">
      <v-sheet elevation="0" class="cnt-wrap wide py-5 px-4 d-flex">
        <v-col cols="col-6 py-0 pl-0 pr-4 inner">
          <span class="label small">{{ $t('총 일수') }}</span>
          <span class="ml-auto cnt">{{ totDayCnt }}</span>
        </v-col>
        <v-col cols="col-6 py-0 pr-0 pl-4 divider inner">
          <span class="label small">{{ $t('신청중') }}</span>
          <span class="ml-auto cnt point-green">{{ appDayCnt }}</span>
        </v-col>
      </v-sheet>
      <v-row class="mt-0 sheet-wrap">
        <v-col>
          <v-sheet elevation="0" class="cnt-wrap py-6">
            <div class="label">
              <v-icon class="mr-1" color="#777e87" size="18"
                >mdi-calendar-check-outline</v-icon
              >{{ $t('사용일수') }}
            </div>
            <div class="cnt">{{ usedDayCnt }}</div>
          </v-sheet>
        </v-col>
        <v-col>
          <v-sheet elevation="0" class="cnt-wrap remain py-6">
            <div class="label">
              <v-icon class="mr-1" color="#777e87" size="18"
                >mdi-shape-outline</v-icon
              >{{ $t('잔여일수') }}
            </div>
            <div class="cnt">{{ restDayCnt }}</div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-0" v-if="GET_APPL_MENU_USE_YN">
      <v-btn
        elevation="0"
        color="blue"
        width="100%"
        @click="toHolidayApplication()"
      >
        <span class="white--text"
          ><v-icon class="mr-2">mdi-emoticon-outline</v-icon
          >{{ $t('휴가 신청하기') }}</span
        >
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/* (공통)휴가현황 카드 컴포넌트 */
import { getHolidayStaInfo } from '@/api/workStatus';
import { mapGetters } from 'vuex';

export default {
  props: {
    gntGubunCd: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    restDayCnt: 0, // 잔여일수
    usedDayCnt: 0, // 사용일수
    appDayCnt: 0, // 신청중일수
    totDayCnt: 0, // 총사용가능일수
  }),

  watch: {
    gntGubunCd() {
      this.fetchHolidayStaInfo();
    },
    GET_DIALOG_CALLBACK(callback) {
      if (callback) {
        this.fetchHolidayStaInfo();
      }
    },
  },

  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_CALLBACK']),
    ...mapGetters('MENU', ['GET_APPL_MENU_USE_YN']),

    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },
  },

  methods: {
    /* 휴가현황 정보조회  */
    async fetchHolidayStaInfo() {
      try {
        const response = await getHolidayStaInfo({
          searchSabun: this.GET_USER_DATA.ssnSabun,
          gntGubunCd: this.gntGubunCd,
        });
        const dataObj = response.data.data;

        const holidayStaInfo = dataObj.holidayStaInfo;
        const gntEqYn = dataObj.gntEqYn;

        if (holidayStaInfo != null) {
          this.totDayCnt = holidayStaInfo.useCnt;
          this.usedDayCnt = holidayStaInfo.usedCnt;
          this.restDayCnt = holidayStaInfo.yearRestCnt - holidayStaInfo.appCnt;
          this.appDayCnt = holidayStaInfo.appCnt;
        }
        if (gntEqYn === 'N') {
          console.log('현재 근태코드와 공제근태코드가 다릅니다.'); // (11/4 논의필요!) 휴가일수가 연차에서 차감되는 경우 안내 필요
        }
      } catch (error) {
        console.log(error);
      }
    },

    /* 휴가 신청화면으로 이동 */
    async toHolidayApplication() {
      const applParam = {
        applCd: '22',
        gntGubunCd: this.gntGubunCd,
        gubun: 'vacations',
      };

      let name = await this.$store.dispatch('ELA/FETCH_MENU_ACTION', applParam);
      this.$router.push({ name });
    },
  },
};
</script>

<style></style>
